import React from 'react';
import css from './SectionOfferingsForm.module.css';
import { FieldTextInput } from '../../../components';
const HoursInputField = ({ label, id, fieldName }) => {
  return (
    <div className={css.fieldGroup}>
      <FieldTextInput
        className={css.field}
        type="number"
        id={id}
        name={fieldName}
        label={label}
        placeholder="0"
      />
    </div>
  );
};

export default HoursInputField;
